import { atom } from 'recoil';

/**
 * ローディング状態を管理するステート
 * 現在実行中のAPIのURLを配列で保持し、配列が空でない限りローディング表示となる。
 * 複数のAPIが並列で実行される場合も、全てが完了するまでローディングが継続する。
 */
const loadingState = atom<string[]>({
  key: 'loading',
  default: [],
});

export default loadingState;
